import React, { useContext } from 'react';

import { media } from 'context';
import { Clickable, Icon, Layout, Text } from 'ds';
import { Color, IconName } from 'shared';

interface TenantPaymentMethodCardOptionProps {
  icon?: IconName;
  title: string;
  customIcon?: React.ReactNode;
  onClick: () => void;
  textColor?: Color;
}

const TenantPaymentMethodCardOption: React.FC<TenantPaymentMethodCardOptionProps> = ({
  icon,
  title,
  onClick,
  customIcon,
  textColor
}) => {
  const { isMobile } = useContext(media);
  return (
    <Clickable onClick={onClick} hoverColor={isMobile ? undefined : 'blue-50'} fullWidth>
      <Layout
        width="100%"
        direction="row"
        gap={isMobile ? 12 : 10}
        align="center"
        height={isMobile ? 52 : 44}
        paddingX={isMobile ? undefined : 16}
      >
        {customIcon ? customIcon : icon ? <Icon name={icon} size="md" stroke={isMobile ? 2 : undefined} /> : null}
        <Text size={isMobile ? 'body-md' : 'body-xs'} semibold={isMobile} color={textColor}>
          {title}
        </Text>
      </Layout>
    </Clickable>
  );
};

export default TenantPaymentMethodCardOption;
